import request from "@/router/axios";

export const getList = (data) => {
  return request({
    url: "/api/produce/flow-meter-snapshot/select/page",
    method: "post",
    data
  });
};
